import { takeLatest, takeEvery, put, call } from "redux-saga/effects";
import apiCall from "../services"
import config from '../config/config.json';
import conciliacion_json from '../config/conciliacion_json.json';

function* getComment(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };
        const requestOptions = {
            headers: headers
        };
        let url = config.credentials.url + '/comment_conciliation/' + actions.query
        const response = yield call(apiCall, 'get', url, requestOptions)

        yield put({ type: "CONCILIATION_COMMENTS_RESPONSE", value: response })
    } catch (error) {
        yield put({ type: "CONCILIATION_COMMENTS_RESPONSE", value: error })
    }
}


function* createComment(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data)
        };

        const response = yield call(apiCall, 'POST', config.credentials.url + '/comment_conciliation/', requestOptions);

        yield put({ type: "CREATE_COMMENTS_RESPONSE", value: response })
    } catch (error) {
        yield put({ type: "CREATE_COMMENTS_RESPONSE", value: error })
    }
}

function* conciliation(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };
        const requestOptions = {
            headers: headers
        };
        let url = (actions.query === null) ? config.credentials.url + '/bank_concilier_sperta/' : config.credentials.url + '/bank_concilier_sperta/?id=' + actions.query
        const response = yield call(apiCall, 'get', url, requestOptions)

        yield put({ type: "CONCILIATION_RESPONSE", value: response })

    } catch (error) {
        yield put({ type: "CONCILIATION_RESPONSE", value: error })
    }
}

function* conciliations(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        let url = (actions.query === null) ? config.credentials.url + '/bank_concilier_sperta/?offset=0&limit=' + actions.limit : config.credentials.url + '/bank_concilier_sperta/' + actions.query

        const response = yield call(apiCall, 'get', url, requestOptions)

        yield put({ type: "CONCILIATIONS_RESPONSE_LIST", value: response })

    } catch (error) {
        yield put({ type: "CONCILIATIONS_RESPONSE_LIST", value: error })
    }
}

function* resumeConciliations(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        let url = (actions.query === null) ? config.credentials.url + '/transaction_summary_conciliation/?offset=0&limit=' + actions.limit : config.credentials.url + '/transaction_summary_conciliation/' + actions.query

        const response = yield call(apiCall, 'get', url, requestOptions)

        yield put({ type: "CONCILIATIONS_RESUME_LIST", value: response })

    } catch (error) {
        yield put({ type: "CONCILIATIONS_RESUME_LIST", value: error })
    }
}

function* resumeConciliationById(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        let url = config.credentials.url + '/transaction_summary_conciliation/' + actions.id + '/';

        const response = yield call(apiCall, 'get', url, requestOptions);

        yield put({ type: "CONCILIATION_RESUME_BY_ID", value: response })
    } catch (error) {
        yield put({ type: "CONCILIATION_RESUME_BY_ID", value: error })
    }
}
function* editResumeConciliation(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data)
        };

        const response = yield call(apiCall, 'put', config.credentials.url + '/transaction_summary_conciliation/' + actions.id + '/', requestOptions)

        yield put({ type: "EDIT_CONCILIATION_RESUME", value: response })
    } catch (error) {
        yield put({ type: "EDIT_CONCILIATION_RESUME", value: error })
    }
}
function* createResumeConciliation(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data)
        };

        const response = yield call(apiCall, 'POST', config.credentials.url + '/transaction_summary_conciliation/', requestOptions)

        yield put({ type: "CREATE_CONCILIATION_RESUME", value: response })
    } catch (error) {
        yield put({ type: "CREATE_CONCILIATION_RESUME", value: error })
    }
}
function* deleteResumeConciliation(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        const response = yield call(apiCall, 'delete', config.credentials.url + '/transaction_summary_conciliation/' + actions.id + '/', requestOptions)
        yield put({ type: "DELETE_CONCILIATION_RESUME", value: response })
    } catch (error) {
        yield put({ type: "DELETE_CONCILIATION_RESUME", value: error })
    }
}

function* filteredConciliation(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        let url = config.credentials.url + '/bank_concilier_sperta/' + actions.query

        const response = yield call(apiCall, 'get', url, requestOptions)

        yield put({ type: "FILTERED_CONCILIATION_RESPONSE", value: response })
    } catch (error) {
        yield put({ type: "FILTERED_CONCILIATION_RESPONSE", value: error })
    }
}

function* exportConciliation(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        let url = config.credentials.url + '/bank_concilier_sperta/' + actions.query

        const response = yield call(apiCall, 'get', url, requestOptions)

        yield put({ type: "EXPORT_CONCILIATION_RESPONSE", value: response })
    } catch (error) {
        yield put({ type: "EXPORT_CONCILIATION_RESPONSE", value: error })
    }
}


function* fileConciliations(actions) {
    let endpointUrl = actions.requestType == "conciliation" ? "bank_conciliation" : "bank_reconciliation";

    try {
        const headers = {
            'Authorization': `Bearer ${actions.access}`,
        };

        const requestOptions = {
            headers: headers,
            body: actions.file
        };
        const response = yield call(apiCall, 'post', config.credentials.url + '/' + endpointUrl + '/', requestOptions)

        yield put({ type: "FILE_RESPONSE_CONCILIATIONS", value: response })
    } catch (error) {
        yield put({ type: "FILE_RESPONSE_CONCILIATIONS", value: error })
    }
}

function* fileConciliationBilling(actions) {
    try {
        const headers = {
            'Authorization': `Bearer ${actions.access}`,
        };

        const requestOptions = {
            headers: headers,
            body: actions.file
        };
        const response = yield call(apiCall, 'post', config.credentials.url + '/conciliation_billing_form/', requestOptions)

        yield put({ type: "FILE_RESPONSE_CONCILIATION_BILLING", value: response })
    } catch (error) {
        yield put({ type: "FILE_RESPONSE_CONCILIATION_BILLING", value: error })
    }
}

function* manualConciliation(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data)
        };

        const response = yield call(apiCall, 'POST', config.credentials.url + '/manual_conciliation/', requestOptions);

        yield put({ type: "RESPONSE_MANUAL_CONCILIATION", value: response })
    } catch (error) {
        yield put({ type: "RESPONSE_MANUAL_CONCILIATION", value: error })
    }
}

function* revert(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };
        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data)
        };
        const response = yield call(apiCall, 'POST', config.credentials.url + '/revert_conciliation/', requestOptions);
        yield put({ type: "RESPONSE_REVERT_CONCILIATION", value: response })
    } catch (error) {
        yield put({ type: "RESPONSE_REVERT_CONCILIATION", value: error })
    }
}

function* checkExportCobranzasExtract(actions) {
    try {
        const headers = {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${actions.access}`,
        };
        const requestOptions = {
            headers: headers,
        };

        const response = yield call(
            apiCall,
            'GET',
            config.credentials.url + '/download_persisted_extract/?bank_name=' + actions.query,
            requestOptions
        );

        yield put({ type: 'DOWNLOAD_EXTRACT_RESPONSE', value: response });
    } catch (error) {
        yield put({ type: 'DOWNLOAD_EXTRACT_RESPONSE', value: error });
    }
}

function* checkExportCobranzasConciliacion(actions) {
    try {
        const headers = {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${actions.access}`,
        };
        const requestOptions = {
            headers: headers,
        };

        const response = yield call(
            apiCall,
            'GET',
            config.credentials.url + '/report/' + actions.hash + '/',
            requestOptions
        );

        yield put({ type: 'REPORT_EXPORT_COBRANZAS_CONCILIACION_RESPONSE', value: response });
    } catch (error) {
        yield put({ type: 'REPORT_EXPORT_COBRANZAS_CONCILIACION_RESPONSE', value: error });
    }
}

function* getSummary(actions) {

    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };
        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data)
        };

        const response = yield call(apiCall, 'POST', config.credentials.url + '/obtain_transaction_summary/', requestOptions);


        yield put({ type: "RESPONSE_TRANSACTION_SUMMARY", value: response })
    } catch (error) {
        yield put({ type: "RESPONSE_TRANSACTION_SUMMARY", value: error })
    }
}

function* transactionType(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        let url = (actions.query === null) ? config.credentials.url + '/transaction_type/?offset=0&limit=' + actions.limit : config.credentials.url + '/transaction_type/' + actions.query

        const response = yield call(apiCall, 'get', url, requestOptions)

        yield put({ type: "TRANSACTIONTYPENAME_RESPONSE_LIST", value: response })
    } catch (error) {
        yield put({ type: "TRANSACTIONTYPENAME_RESPONSE_LIST", value: error })
    }
}

function* addTransactionTypeN(actions) {

    try {

        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };
        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data)
        };

        const response = yield call(apiCall, 'POST', config.credentials.url + '/transaction_type/', requestOptions);

        yield put({ type: "TRANSACTIONTYPENAME_RESPONSE", value: response })

    } catch (error) {
        yield put({ type: "TRANSACTIONTYPENAME_RESPONSE", value: error })
    }
}

function* editTransactionTypeN(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data)
        };

        const response = yield call(apiCall, 'put', config.credentials.url + '/transaction_type/' + actions.id + '/', requestOptions)

        yield put({ type: "TRANSACTIONTYPENAME_RESPONSE", value: response })

    } catch (error) {
        yield put({ type: "TRANSACTIONTYPENAME_RESPONSE", value: error })
    }
}

function* deleteTransactionTypeN(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        const response = yield call(apiCall, 'delete', config.credentials.url + '/transaction_type/' + actions.id + '/', requestOptions)

        yield put({ type: "DELETE_TRANSACTIONTYPENAME", value: response })
    } catch (error) {
        yield put({ type: "DELETE_TRANSACTIONTYPENAME", value: error })
    }
}

function* deleteTransactionItemN(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        const response = yield call(apiCall, 'delete', config.credentials.url + '/transaction_item/' + actions.id + '/', requestOptions)

        yield put({ type: "DELETE_TRANSACTIONITEMNAME", value: response })
    } catch (error) {
        yield put({ type: "DELETE_TRANSACTIONITEMNAME", value: error })
    }
}

function* transactionItemBank(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        let url = (actions.query === null) ? config.credentials.url + '/transaction_item/?offset=0&limit=' + actions.limit + '&item_type=bank' : config.credentials.url + '/transaction_item/' + actions.query + '&item_type=bank'

        const response = yield call(apiCall, 'get', url, requestOptions)

        yield put({ type: "TRANSACTIONITEMBANKNAME_RESPONSE_LIST", value: response })
    } catch (error) {
        yield put({ type: "TRANSACTIONITEMBANKNAME_RESPONSE_LIST", value: error })
    }
}

function* transactionItemSperta(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        let url = (actions.query === null) ? config.credentials.url + '/transaction_item/?offset=0&limit=' + actions.limit + '&item_type=sperta' : config.credentials.url + '/transaction_item/' + actions.query + '&item_type=sperta'

        const response = yield call(apiCall, 'get', url, requestOptions)

        yield put({ type: "TRANSACTIONITEMSPERTANAME_RESPONSE_LIST", value: response })
    } catch (error) {
        yield put({ type: "TRANSACTIONITEMSPERTANAME_RESPONSE_LIST", value: error })
    }
}

function* addTransactionItemN(actions) {

    try {

        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };
        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data)
        };

        const response = yield call(apiCall, 'POST', config.credentials.url + '/transaction_item/', requestOptions);

        yield put({ type: "TRANSACTIONITEMNAME_RESPONSE", value: response })

    } catch (error) {
        yield put({ type: "TRANSACTIONITEMNAME_RESPONSE", value: error })
    }
}

function* editTransactionItemN(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data)
        };

        const response = yield call(apiCall, 'put', config.credentials.url + '/transaction_item/' + actions.id + '/', requestOptions)

        yield put({ type: "TRANSACTIONITEMNAME_RESPONSE", value: response })

    } catch (error) {
        yield put({ type: "TRANSACTIONITEMNAME_RESPONSE", value: error })
    }
}


export function* getConciliation() {
    yield takeEvery("GET_CONCILIATION", conciliation)
}
export function* getConciliationsList() {
    yield takeEvery("GET_CONCILIATIONS", conciliations)
}
export function* getResumeConciliationsList() {
    yield takeEvery("GET_RESUME_CONCILIATIONS", resumeConciliations)
}
export function* getResumeConciliationById() {
    yield takeEvery("GET_RESUME_CONCILIATION_BY_ID", resumeConciliationById)
}
export function* editResumeConciliationById() {
    yield takeEvery("EDIT_RESUME_CONCILIATION", editResumeConciliation)
}
export function* createResumeConciliationById() {
    yield takeEvery("CREATE_RESUME_CONCILIATION", createResumeConciliation)
}

export function* deleteResumeConciliationById() {
    yield takeEvery("DELETE_RESUME_CONCILIATION_BY_ID", deleteResumeConciliation)
}

export function* getManualConciliation() {
    yield takeEvery("GET_MANUAL_CONCILIATION", manualConciliation)
}

export function* revertConciliation() {
    yield takeEvery("REVERT_CONCILIATION", revert)
}

export function* getFilteredConciliation() {
    yield takeEvery("GET_FILTERED_CONCILIATION", filteredConciliation)
}

export function* getExportConciliation() {
    yield takeEvery("GET_EXPORT_CONCILIATION", exportConciliation)
}

export function* uploadFileConciliations() {
    yield takeEvery("UPLOAD_FILE_CONCILIATIONS", fileConciliations)
}

export function* getCommentConciliation() {
    yield takeEvery("GET_COMMENT_CONCILIATION", getComment)
}

export function* createCommentConciliation() {
    yield takeEvery("CREATE_COMMENT_CONCILIATION", createComment)
}

export function* uploadFileConciliationBilling() {
    yield takeEvery("UPLOAD_FILE_CONCILIATION_BILLING", fileConciliationBilling)
}
export function* checkExportCobranzasConciliacionList() {
    yield takeEvery('CHECK_EXPORT_COBRANZA_CONCILIACION', checkExportCobranzasConciliacion);
}
export function* checkExportCobranzasExtractSaga() {
    yield takeEvery('GET_EXPORT_COBRANZA_EXTRACT', checkExportCobranzasExtract);
}
export function* getTransactionSummary() {
    yield takeEvery("GET_TRANSACTION_SUMMARY", getSummary)
}

export function* getTransactionTypeNameListSent() {
    yield takeEvery("GET_TRASACTIONTYPE_NAME", transactionType)
}

export function* addTransactionTypeName() {
    yield takeEvery("ADD_TRASACTIONTYPE_NAME", addTransactionTypeN)
}

export function* editTransactionTypeName() {
    yield takeEvery("EDIT_TRASACTIONTYPE_NAME", editTransactionTypeN)
}

export function* deleteTransactionTypeName() {
    yield takeEvery("DELETE_TRASACTIONTYPE_NAME", deleteTransactionTypeN)
}

export function* deleteTransactionItemName() {
    yield takeEvery("DELETE_TRASACTIONITEM_NAME", deleteTransactionItemN)
}

export function* getTransactionItemBankNameListSent() {
    yield takeEvery("GET_TRASACTIONITEMBANK_NAME", transactionItemBank)
}

export function* getTransactionItemSpertaNameListSent() {
    yield takeEvery("GET_TRASACTIONITEMSPERTA_NAME", transactionItemSperta)
}

export function* addTransactionItemName() {
    yield takeEvery("ADD_TRASACTIONITEM_NAME", addTransactionItemN)
}

export function* editTransactionItemName() {
    yield takeEvery("EDIT_TRASACTIONITEM_NAME", editTransactionItemN)
}





